import { DashboardCartAndSettings } from '@cloud-twin-v2/cloud-twin-shared/filtrable-items/dashboard-cart-and-settings';

export class DashboardChildConfigPopupData extends DashboardCartAndSettings {}
